import { useContext, useEffect, useState } from 'react'

// New imports
import axios from 'axios'
import axio from 'axios'
import Modal from 'react-modal'
import { EditIntent, IntentDetail, NewIntent } from '../../components/intents'
import Swal from 'sweetalert2'
import EditProjectModal from '../../components/EditProjectModal'
import '../../styles/answerCRUD.scss'
import '../../styles/answers.scss'
import { customModal } from '../../styles/customModal'
import TitleBar from "../../components/TitleBar";

import { projectContext, loadingContext, unfolder, urlValue, useTranslate } from '../../lib'
import { viewShield } from '../../lib/security/viewShield';

import '../../styles/project.scss'
import '../../styles/general.scss'
import { useForm } from "react-hook-form";
import SideBarGenAI from '../../components/ProjectGenAI/SideBarGenAI'
import { InputNesting, TextareaNesting } from '../../components/common/Inputs/Input'
import { useRef } from 'react'

export default function ProjectGenAI() {

  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [isModalOpen, setIsModalOpen] = useState({
    drop: false,
    edit: false,
  })

  const [refresh, setRefresh] = useState(0);
  const [imgSelected, setImgSelected] = useState(null);

  const closeModal = () => {
    setIsModalOpen({ drop: false, edit: false })
  }

  const openModal = () => {
    setIsModalOpen({ drop: false, edit: true })
  }

  const [loading, setLoading] = useContext(loadingContext)
  const [error, setError] = useState({ name: "" })
  const [projectName, setProjectName] = useState();
  const [description, setDescription] = useState();
  const [welcomeMsg, setWelcomeMsg] = useState();
  const { t } = useTranslate();
  const [imageName, setImageName] = useState(t('menu.uploadProjectImage'));
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const name_ref = useRef();
  const description_ref = useRef();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  const getProject = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
        'Content-Type': 'application/json',
      },
    })
      .then(function (response) {
        setSelectedProject(response.data)
        setProjectName(response.data.name)

        // Seguridad XSS
        //const safeWelcomeMsg = viewShield(response.data.welcome_msg);
        const safeWelcomeMsg = response.data.welcome_msg;
        const welcomeInput = document.getElementById('welcome_msg');
        if (welcomeInput) {
          welcomeInput.innerHTML = safeWelcomeMsg;
        }

        setLoading(false)
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }

  useEffect(() => {
    getProject()
  }, [])

  const saveProject = async (e) => {
    e.preventDefault();

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    const name = name_ref.current.value;
    let convertedFile = ""

    if (image) {
      convertedFile = await convertToBase64(image)
    }

    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;

      setError({ ...error, name: t('errors.nameInvalid') })
    }
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    if (ok) {

      setLoading(true);
      selectedProject.metadata.description = description_ref.current.value
      const dataSend = {

        id: selectedProject.id,
        name: name_ref.current.value,
        welcome_msg: selectedProject.welcome_msg,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        metadata: { "description": selectedProject.metadata.description, "language": selectedProject.metadata.language },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: {"imageName": convertedFile ? imageName : selectedProject.image, "url": ""} || null,
        imageFile: convertedFile || null,
        time_hold_amount: selectedProject.AmountTimeHold,
        time_hold_seconds: selectedProject.TimeSecondHold,
        use_hold: selectedProject.useHold,
        url_tp_simulation: selectedProject.url_tp_simulation,
        channel: selectedProject.channel,
        random_voice: selectedProject.random_voice,
        use_default_sentiment: selectedProject.use_default_sentiment,
        bot_sentiment: selectedProject.bot_sentiment,
        model_sentiment: selectedProject.model_sentiment,
        category: selectedProject.category,
        outbound_call: selectedProject.outbound_call,
        transcription: selectedProject.transcription,

        campaing: selectedProject.campaing,
        sub_campaing: selectedProject.sub_campaing,
        voice: selectedProject.voice_id,
        type: selectedProject.type,

        industry: selectedProject.industry,
        problem: selectedProject.industry,
        solution: selectedProject.solution,
        contact_driver_context: selectedProject.gen_ai.contact_driver_context,
        evaluation_questions: selectedProject.gen_ai.evaluation_questions,
        model_llm: selectedProject.model_llm,
        temperature: selectedProject.temperature,
        top_p: selectedProject.top_p,
        top_k: selectedProject.top_k,
        minimum_passing_score: selectedProject.minimum_passing_score,
        num_simulation_steps: selectedProject.num_simulation_steps,
        min_call_time: selectedProject.min_call_time,
        max_call_time: selectedProject.max_call_time,

      }
      axios({
        method: 'post',
        url: `${urlValue}/studio/project/update`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          setSelectedProject({
            ...selectedProject, name: name,
          })
          Swal.fire(
            {
              title: `${t('common.success')}!`,
              icon: "success",
              showCloseButton: true,
              showCancelButton: false,
              // closeButtonHtml: "<div>No</div>",
              confirmButtonText: 'Ok',
              cancelButtonText: t('common.no'),
              confirmButtonColor: "#0087ff",
              iconColor: "#0087ff"
            }).then(() => {
              setRefresh(refresh + 1)
              getProject();
              closeModal();
              setLoading(false)
              setImageName(t('menu.uploadProjectImage'));
            })

        })
        .catch(function (error) {
          setLoading(false);
          console.error("error ", error)
        })
    }

  }

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
    })
  }

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
    }
  }

  const changeImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImgSelected(URL.createObjectURL(e.target.files[0]));
      setImage({ name: e.target.files[0].name, file: e.target.files[0] })
    }
  }
  return (
    <div>
      <div className="container-project general-container" id="container-proj">
        <SideBarGenAI project={selectedProject} active={'Project'} />
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <h1 className="ml-2">{t('common.project')}</h1>
          <form onSubmit={saveProject} className="body d-flex flex-column pl-2  ">

            <div className="description mt-3">
              <div>

                <InputNesting
                  style={{ width: "fit-content", textTransform: 'capitalize', fontSize: 20, color: '#0B5FA3', fontWeight: "bold" }}
                  ref={name_ref}
                  id="name" label={false}
                  defaultValue={projectName}
                  // tooltip={true}
                  // tooltipText={`Only these characters are accepted A-Za-z0-9-,._'¿?`}
                  placeholder={t('menu.newProjectName')}
                />


                {/* <div className='img-content'>
                  
                   {imgSelected ?  <img  src={imgSelected}  alt='' className='img-preview' /> : 
                   selectedProject?.image ? <img  src={selectedProject.image}  alt='' className='img-preview' />: null}
                 <div className='img-file-div'>
                    <div className='upload-img-div'>
                      <p className='name-img'>{selectedProject.imageName}</p>
                      <div className='content-upload'> 
                        <input onChange={changeImage} type='file' className='input-file' />
                        <button className='btn-upload'>Upload</button>
                      </div>
                    </div>
                 </div>
              </div> */}
              </div>

              <div className="inputs" style={{ marginTop: 20 }} id="image">
                <div className="input settings-container d-flex flex-column">
                  <img src={selectedProject.image} id="image_uploaded" width="200" alt="" style={{ display: imagePreview ? 'none' : 'block' }} />
                  <img src={imagePreview} id="image_preview" style={{ display: imagePreview ? 'block' : 'none' }} width="200" alt="" />
                  <div className="d-flex flex-column justify-end ml-2" style={{ minWidth: 100 }}>
                    <div className="mb-3" style={{ maxWidth: 150, fontSize: 13 }}>{selectedProject.imageName}</div>
                    <label className="custom-file mt-4" style={{ width: '100%' }}>
                      <input
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (file && file.type.startsWith('image/')) {
                            setImage(e.target.files[0]);
                            setImageName(e.target.files[0].name);
                            onImageChange(e);
                          } else {
                            alert(t('alerts.validImage'));
                            e.target.value = null; // limpia el input
                          }
                        }}
                        type="file"
                        accept="image/png, .jpeg, .jpg"
                      />
                      {imageName}
                    </label>
                  </div>
                </div>
              </div>




            </div>
            <div className="data mt-2">
              <TextareaNesting
                ref={description_ref} id="description"
                title={t('common.description')} row={7}
                containerClass="mt-2" labelClass="font-bold"
                defaultValue={typeof selectedProject?.metadata?.description !== "string" ? "" : selectedProject?.metadata?.description}
                placeholder={t('menu.genai.detailedDescriptionPlaceholder')}
              />

              <h3 style={{ fontSize: 16, marginTop: 25, color: '#474746' }}>{t('common.metadata')}</h3>
              <p style={{ fontSize: 16, color: '#575756' }}>{t('common.availability')}</p>
              <p style={{ fontSize: 16, color: '#575756' }}>{selectedProject?.metadata?.availability}</p>
              <p style={{ fontSize: 16, color: '#575756' }}>{t('common.testingEndpoint')}</p>
              <p style={{ fontSize: 16, color: '#575756' }}>{selectedProject?.metadata?.testing_endpoint}</p>
              <p style={{ fontSize: 16, color: '#575756' }}>{t('common.language')}</p>
              <p style={{ fontSize: 16, color: '#575756' }}>{selectedProject?.metadata?.language}</p>
            </div>
            <div className='cont-buttons mt-5 w-100'>
              <div className="buttons d-flex flex-row justify-end pr-3">
                <button className="create btn-primary" type="submit" style={{ backgroundColor: "#0087FF" }}>
                  {t('common.save')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/*<Modal isOpen={isModalOpen.drop} onClose={handleClose} style={customModal} ariaHideApp={false}>*/}
      {/*  <div id="container-modal">*/}
      {/*    <img src="/icons/alert.png" />*/}
      {/*    <h1>You are about to delete a project.</h1>*/}
      {/*    <h1>{t('menu.deleteConfirmQuestion')}</h1>*/}
      {/*    <div className="buttons-modal">*/}
      {/*      <button*/}
      {/*        onClick={handleClose}*/}
      {/*        className="cancel"*/}
      {/*      >*/}
      {/*        Cancel*/}
      {/*      </button>*/}
      {/*      <button onClick={deleteProject} className="accept">*/}
      {/*        Yes*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}

      {/*<EditProjectModal*/}
      {/*  isModalOpen={isModalOpen.edit}*/}
      {/*  closeModal={closeModal}*/}
      {/*  update={() => { getProject() }}*/}
      {/*  refresh={refresh}*/}
      {/*  setRefresh={setRefresh}*/}
      {/*/>*/}
    </div>
  )
}
